const config = {

    kefu:"https://vue.livehelp100service.com/84eef5cf334defedf65bcefjkfle-keli4be8e1fb56ccfe31fdbadd5b446c1c57ba6dbaa45d84bc4b766980b9460ea8b7",
    iosDown:"https://n2m1z.clydt.com/QbWg4SCuI/ntk0mdzimd?p=1",
    iosDonw2:"https://n2m1z.clydt.com/QbWg4SCuI/ntk0mdzimd?p=1",
    android:"https://ymzlm.stcrk.cn/pESX/ntk0mdzimd",
    android2:"https://ymzlm.stcrk.cn/pESX/ntk0mdzimd",


}

export default config;